import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { TostMessageContext } from "../context/TostMessage";
import { useReactToPrint } from "react-to-print";
import { IoMdArrowRoundBack, IoMdCheckmarkCircleOutline } from "react-icons/io"
import { FulfillOrder } from "../components/fulfill_order";


export default function OrderDetails() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [pageLoading, setPageLoading] = useState(true);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();
    const {setTostMessage} = useContext(TostMessageContext)
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});

    const componentRef = useRef();

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    async function getData() {
        const formData = new FormData();
        formData.append('reference', reference);

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_order_receipt.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                setPageData(response.data)
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: 'Unable to load payment info'
                })
            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
      {showModal &&
        <FulfillOrder
            setShowModal={setShowModal}
            showModal={showModal}
            showDetails={showDetails}
        />
        }

        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            {/* <div className="flex items-center justify-start gap-x-3">
                <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                <h2 className="text-2xl text-black font-bold">{'Go Back'}</h2>
            </div> */}
            <div className="gap-y-2 md:gap-y-0 flex flex-col mb-5 md:flex-row md:items-center justify-between">
                <div className="flex flex-row items-center gap-x-2">
                    <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                    <h2 className="text-xl md:text-2xl text-black font-bold">{'Manage Products'}</h2>
                </div>
                <div className="rounded-xl border p-2 flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <button onClick={() => {setShowModal(true);setShowDetails({row: pageData})} } className="bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                        <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Fulfill Order</span>
                    </button>
                </div>
            </div>
            <div className="max-w-6xl w-full mx-auto md:px-4 py-6">
                <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center md:p-4">
                <div ref={componentRef} className="w-full rounded-2xl shadow-sm">
                    <div className="p-6 sm:p-8">
                    {/* Header */}
                    <div className="flex flex-col items-center text-center gap-4">
                        <IoMdCheckmarkCircleOutline size={60} className="h-16 w-16 text-teal-600" />
                        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                        Thank you! Your order has been placed.
                        </h1>
                        <p className="text-gray-500 text-sm sm:text-base">
                        Your order <span className="font-medium">#{pageData?.reference}</span> has been confirmed and will be shipped soon.
                        </p>
                    </div>

                    {/* Order Summary */}
                    <div className="mt-8 border rounded-xl p-4 sm:p-6">
                        <h2 className="text-lg font-semibold text-teal-700 mb-4">Order Summary</h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                        <div>
                            <p className="text-gray-500">Order Number</p>
                            <p className="font-medium">#{pageData?.reference}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Order Date</p>
                            <p className="font-medium">{pageData?.time}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Payment Method</p>
                            <p className="font-medium">{pageData?.channel}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Total Amount</p>
                            <p className="font-semibold text-orange-600">{pageData?.order_amount}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Discouht Applied</p>
                            <p className="font-semibold text-orange-600">{pageData?.discount_applied}</p>
                        </div>
                        </div>

                        <hr className="my-6" />

                        {/* Items */}
                        <div className="space-y-4">
                            {pageData?.order_items?.map((item, index) => 
                                <Item
                                    name={item.name}
                                    qty={item.qty}
                                    price={item.item_amount}
                                    img={item.thumbnail}
                                    selected_extras={item.selected_extras}
                                />
                            )}
                        </div>
                    </div>

                    {/* Footer Actions */}
                    <div className="mt-8">
                        <p className="text-sm text-gray-400 text-center mt-4">
                        A confirmation email has been sent to {pageData?.email}
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  );
}


function Item({ name, qty, price, img, selected_extras }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center gap-4">
      <img
        src={img}
        alt={name}
        className="h-12 w-12 rounded-md object-cover"
      />
      <div className="flex-1">
        <p className="font-medium text-gray-800">{name}</p>
        <p className="text-sm text-gray-500">Qty: {qty}</p>
        <p className="text-sm text-gray-500">{selected_extras}</p>
      </div>
      <p className="font-medium text-gray-700">{price}</p>
    </div>
  );
}